import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import ProjectsIcon from '@components/Icon/ProjectsIcon'
import StarIcon from '@components/Icon/Star'
import { getTimezoneOffsetById } from '@atheneum/api/dist/lib'
import '../Sidebar.sass'

class ClientContact extends Component {
  static propTypes = {
    id: PropTypes.number,
    clientStore: PropTypes.object,
    sidebarStore: PropTypes.object,
    staticData: PropTypes.object
  }

  constructor (props) {
    super(props)
    const { id } = this.props
    props.clientStore.get(id)
  }

  renderPhones = () => {
    const { client } = this.props.clientStore
    if (!client.address || client.address.phones.length < 1) {
      return <p>-</p>
    }

    return client.address.phones.map(phone => {
      return <p key={phone.id}>{phone.phoneNum}</p>
    })
  }

  handleClientContactNameClick = () => {
    const { sidebarStore } = this.props
    sidebarStore.closeSidebar()
  }

  render () {
    const { client } = this.props.clientStore
    if (!client) return null

    return (
      <div>
        <h1
          className='sidebar-wrapper__content__link'
          onClick={this.handleClientContactNameClick}
        >
          <NavLink to={`/client-contact/${client.id}`}>
            {client.title} {client.fullName}
          </NavLink>
        </h1>

        <p className='group'>{client.client.office.officeName}</p>

        <div className='group'>
          <div className='icon-label'>
            <StarIcon className='star-icon' />
            <p>{client.averageFeedback || '-'}</p>

            <ProjectsIcon />
            <p>-</p>
          </div>
        </div>

        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Timezone
          </span>
          <p>
            {client.address
              ? getTimezoneOffsetById({
                  id: client.address.timezoneId,
                  staticData: this.props.staticData,
                  hideIsoCode: false
                })
              : null}
          </p>
        </div>

        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Personal phone
          </span>
          {this.renderPhones()}
        </div>

        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Email
          </span>
          <p>
            <a href={'mailto:' + client.email}>{client.email}</a>
          </p>
        </div>

        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Address
          </span>
          <p>
            {client.address
              ? client.address.address1 || client.address.address2
              : '-'}
          </p>
        </div>
      </div>
    )
  }
}

export default inject('sidebarStore', 'clientStore', 'staticData')(
  observer(ClientContact)
)
